import { Result, TransportSessionBuilder } from "@peercolab/engine"
import { APIAuthInfo } from "../Session"

export function backofficeServerInterceptors(builder: TransportSessionBuilder, url: string, authInfoProvider: () => APIAuthInfo | undefined): void {
    builder
      .interceptPattern('PetKey.Main.Model.1_0_Initial.Backoffice.', async (input, ctx) => {
        const authInfo = authInfoProvider()
        if (!authInfo?.isAuthenticated()) {
          return Result.failed(401, "BackofficeServer.Unauthorized", "The client is not authorized")
        }
        const token = await authInfo.getToken()
        if (!token) {
          return Result.failed(401, "BackofficeServer.Unauthorized", "Failed to get authorization token")
        }
      
        const response = await fetch(url + "?" + ctx.operation.id, {
          method: "POST",
          headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + token
          },
          body: ctx.serializeRequest(input)
        });
        const data = await response.text();
        if (!response.ok) {
            return Result.failed(response.status, data)
        }
        return ctx.deserializeResult(data)
      })
}